import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AutomationLogsStore } from 'pages/settings/pages/integrations//store/automationLogsStore'

const AutomationLogsContext = createContext<AutomationLogsStore | null>(null)

export const useAutomationLogsContext = () => {
  const context = useContext(AutomationLogsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AutomationLogsProvider')

  return context
}

export const AutomationLogsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new AutomationLogsStore(entities), [])

  return <AutomationLogsContext.Provider value={store}>{children}</AutomationLogsContext.Provider>
}
